import { CatalogItem } from '~/features/catalog/models/catalog-item';

export const popularCatalogItems: CatalogItem[] = [
  {
    key: 'nd608',
    slug: 'generative-ai--nd608',
    hasStagingData: false,
    isFree: false,
    image:
      'https://video.udacity-data.com/topher/2025/November/69178ba1_generative-ai-nd-mocha-1200x900/generative-ai-nd-mocha-1200x900.jpg',
    syllabus: {
      asset: {
        url: 'https://cdn.sanity.io/files/tlr8oxjg/production/b545cc3ab39710604fc3dd28d16ae10ce85b4535.pdf',
      },
    },
    programDescriptionOverride: null,
    reviewSummary: {
      numberOfReviews: 29,
      starsAverage: 4.9,
    },
    createdAt: '2023-09-11T19:40:36.398Z',
    difficultyLevel: 'Intermediate',
    teachesSkills: [],
    schools: [
      {
        uri: 'taxonomy:b8b37a22-80bb-45fe-8c41-7d7179cc306d',
        name: 'artificial intelligence',
      },
    ],
    title: 'Generative AI',
    semanticType: 'Degree',
    duration: '2 months',
    rawDuration: 2995,
    rawDurationDisplay: '50 hours',
    summary:
      "Embark on a transformative journey into Generative AI!  We'll start by diving into the essentials with an introductory course, progress to mastering text generation with Large Language Models, unravel the complexities of image creation in computer vision and cap it off by bringing AI to life in real-world applications. From foundational theories to building sophisticated chatbots and AI agents, this program will empower you with job-ready skills in the exciting field of Generative AI.",
  },
  {
    key: 'nd900',
    slug: 'agentic-ai--nd900',
    hasStagingData: false,
    isFree: false,
    image:
      'https://video.udacity-data.com/topher/2025/June/6862c852_agentic-ai-nanodegree-plp-1456-x-825/agentic-ai-nanodegree-plp-1456-x-825.jpg',
    syllabus: null,
    programDescriptionOverride: null,
    reviewSummary: {
      numberOfReviews: 9,
      starsAverage: 4.7,
    },
    createdAt: '2025-01-14T19:51:24.272Z',
    difficultyLevel: 'Intermediate',
    teachesSkills: [],
    schools: [
      {
        uri: 'taxonomy:b8b37a22-80bb-45fe-8c41-7d7179cc306d',
        name: 'artificial intelligence',
      },
    ],
    title: 'Agentic AI',
    semanticType: 'Degree',
    duration: '2 months',
    rawDuration: 3041,
    rawDurationDisplay: '51 hours',
    summary:
      "Go beyond single chatbots to engineer sophisticated, coordinated teams of AI agents. This Nanodegree guides you from advanced prompting techniques like Chain-of-Thought and ReAct to designing agentic workflows with patterns like Routing and Parallelization. You'll master building and orchestrating agents in Python that can reason, plan, and use tools to interact with databases and external APIs. Build a powerful portfolio by tackling hands-on projects, including a multi-agent travel planner, an AI-powered project manager, and a fully automated sales system, to solve real-world problems.",
  },
  {
    key: 'nd089',
    slug: 'ai-programming-python-nanodegree--nd089',
    hasStagingData: true,
    isFree: false,
    image: 'https://video.udacity-data.com/topher/2024/October/6709877c_nd089/nd089.jpg',
    syllabus: {
      asset: {
        url: 'https://cdn.sanity.io/files/tlr8oxjg/production/85a57092f82acfa28186b72fd7017ce61a9cb9f6.pdf',
      },
    },
    programDescriptionOverride: null,
    reviewSummary: {
      numberOfReviews: 624,
      starsAverage: 4.7,
    },
    createdAt: '2021-10-25T18:42:11.381Z',
    difficultyLevel: 'Beginner',
    teachesSkills: [],
    schools: [
      {
        uri: 'taxonomy:b8b37a22-80bb-45fe-8c41-7d7179cc306d',
        name: 'artificial intelligence',
      },
      {
        uri: 'taxonomy:c7075247-28e1-4047-9a11-d86f2a3143d5',
        name: 'autonomous systems',
      },
      {
        uri: 'taxonomy:d5b00600-d85f-4c4a-a493-e7ed9374be89',
        name: 'programming and development',
      },
      {
        uri: 'taxonomy:0797c703-1d76-487a-9219-b84cf74b66a5',
        name: 'data science',
      },
    ],
    title: 'AI Programming with Python',
    semanticType: 'Degree',
    duration: '3 months',
    rawDuration: 4362,
    rawDurationDisplay: '73 hours',
    summary:
      'Develop a strong foundation in Python programming for AI, utilizing tools like NumPy, pandas, and Matplotlib for data analysis and visualization. Learn how to use, build, and train machine learning models with popular Python libraries. Implement neural networks using PyTorch. Gain practical experience with deep learning frameworks by applying your skills through hands-on projects. Explore generative AI with Transformer neural networks, learn to build, train, and deploy them with PyTorch, and leverage pre-trained models for natural language processing tasks. Designed for individuals with basic programming experience, this program prepares you for advanced studies in AI and machine learning, equipping you with the skills to begin a career in AI programming.',
  },
  {
    key: 'nd036',
    slug: 'product-manager-nanodegree--nd036',
    hasStagingData: true,
    isFree: false,
    image: 'https://video.udacity-data.com/topher/2024/October/67098755_nd036/nd036.jpg',
    syllabus: null,
    programDescriptionOverride: null,
    reviewSummary: {
      numberOfReviews: 632,
      starsAverage: 4.7,
    },
    createdAt: '2021-10-04T18:26:28.954Z',
    difficultyLevel: 'Beginner',
    teachesSkills: [],
    schools: [
      {
        uri: 'taxonomy:0dba323e-c4c6-4d09-bf98-365cf420a83a',
        name: 'product management',
      },
    ],
    title: 'Product Manager',
    semanticType: 'Degree',
    duration: '2 months',
    rawDuration: 3000,
    rawDurationDisplay: '50 hours',
    summary:
      'Build job-ready skills for a successful PM career with this comprehensive Nanodegree program. Learn the fundamentals of product management from strategy planning to launch with expert guidance and hands-on projects.',
  },
  {
    key: 'nd881',
    slug: 'ai-trading-strategies--nd881',
    hasStagingData: false,
    isFree: false,
    image: 'https://video.udacity-data.com/topher/2025/July/688bc3cb_nd881/nd881.jpg',
    syllabus: null,
    programDescriptionOverride: null,
    reviewSummary: {
      numberOfReviews: 2,
      starsAverage: 3,
    },
    createdAt: '2024-10-02T16:07:16.058Z',
    difficultyLevel: 'Advanced',
    teachesSkills: [
      {
        uri: 'taxonomy:50ae698a-09d7-4c98-a101-d8d5ff6e0ef3',
        name: 'Automated plan optimization',
      },
      {
        uri: 'taxonomy:b77ad51a-4a20-47d5-b042-14137401b4b9',
        name: 'Backtesting',
      },
    ],
    schools: [
      {
        uri: 'taxonomy:b8b37a22-80bb-45fe-8c41-7d7179cc306d',
        name: 'artificial intelligence',
      },
    ],
    title: 'AI Trading Strategies',
    semanticType: 'Degree',
    duration: '4 months',
    rawDuration: 5755,
    rawDurationDisplay: '96 hours',
    summary:
      'Start mastering AI-powered trading with this Nanodegree. Learn to build, backtest, and optimize sophisticated AI-driven trading models, gaining practical skills to succeed in dynamic financial markets.',
  },
  {
    key: 'nd025',
    slug: 'data-scientist-nanodegree--nd025',
    hasStagingData: true,
    isFree: false,
    image: 'https://video.udacity-data.com/topher/2025/July/688bd058_nd025/nd025.jpg',
    syllabus: null,
    programDescriptionOverride: null,
    reviewSummary: {
      numberOfReviews: 811,
      starsAverage: 4.8,
    },
    createdAt: '2021-06-21T14:53:06.633Z',
    difficultyLevel: 'Advanced',
    teachesSkills: [],
    schools: [
      {
        uri: 'taxonomy:0797c703-1d76-487a-9219-b84cf74b66a5',
        name: 'data science',
      },
    ],
    title: 'Data Scientist',
    semanticType: 'Degree',
    duration: '3 months',
    rawDuration: 3670,
    rawDurationDisplay: '61 hours',
    summary:
      'This advanced Nanodegree prepares you to tackle data science at scale. Work with AI best practices, build production-ready projects, and gain the confidence to lead data-driven solutions.',
  },
  {
    key: 'nd088',
    slug: 'ai-product-manager-nanodegree--nd088',
    hasStagingData: true,
    isFree: false,
    image: 'https://video.udacity-data.com/topher/2024/October/6709877b_nd088/nd088.jpg',
    syllabus: null,
    programDescriptionOverride: null,
    reviewSummary: {
      numberOfReviews: 329,
      starsAverage: 4.4,
    },
    createdAt: '2021-10-19T17:54:29.254Z',
    difficultyLevel: 'Intermediate',
    teachesSkills: [
      {
        uri: 'taxonomy:407f95e3-3a4b-4574-8bc7-ffb6677021e6',
        name: 'Computer vision business context',
      },
      {
        uri: 'taxonomy:b4635b34-e2b5-4000-b215-a881d8a27153',
        name: 'Model bias analysis',
      },
      {
        uri: 'taxonomy:affa4f03-8600-4f39-85d1-2c9731e6b2b4',
        name: 'Model performance metrics',
      },
      {
        uri: 'taxonomy:aeafe8fb-4b2d-484c-9cb5-c9eb4dac1a13',
        name: 'NLP proficiency',
      },
      {
        uri: 'taxonomy:df8e168f-a83d-467c-b398-5ae6550c853c',
        name: 'Dataset annotation',
      },
      {
        uri: 'taxonomy:2491e4d1-f5d5-4b84-9bee-8fd47ab7248b',
        name: 'Model bias mitigation',
      },
      {
        uri: 'taxonomy:a6e97820-fcab-4fd3-af90-e01c3b472dbd',
        name: 'Recommendation engine business context',
      },
      {
        uri: 'taxonomy:a5916922-9458-41e6-bf9e-336c0cccb15b',
        name: 'Time-Series Forecasting Business Context:',
      },
      {
        uri: 'taxonomy:29abb81a-ddab-40f4-9458-fa55bc5bdf82',
        name: 'Stakeholder management',
      },
      {
        uri: 'taxonomy:407f95e3-3a4b-4574-8bc7-ffb6677021e6',
        name: 'Computer vision business context',
      },
      {
        uri: 'taxonomy:e0ee74b6-30fd-4d69-bbd8-863437c4c55e',
        name: 'Data limitations and biases',
      },
      {
        uri: 'taxonomy:ee575f3b-7b44-40b4-94ac-71c72e8b5ea2',
        name: 'AI fluency',
      },
      {
        uri: 'taxonomy:b273eec4-d85a-42c1-89db-322b77a2dc90',
        name: 'NLP business context',
      },
      {
        uri: 'taxonomy:2c01e9cd-6105-4e71-8427-189eec783f30',
        name: 'Types of ML applications',
      },
      {
        uri: 'taxonomy:bd4a8a0d-0481-400d-96ad-c03545344b64',
        name: 'GenAI Use Cases',
      },
      {
        uri: 'taxonomy:dbd5a52b-0ebc-4930-bae7-b4a79a487dba',
        name: 'Time-Series Forecasting Basics',
      },
      {
        uri: 'taxonomy:affa4f03-8600-4f39-85d1-2c9731e6b2b4',
        name: 'Model performance metrics',
      },
      {
        uri: 'taxonomy:a197d529-e3a7-438c-85bc-879ae6385eb1',
        name: 'Machine learning use cases',
      },
      {
        uri: 'taxonomy:affa4f03-8600-4f39-85d1-2c9731e6b2b4',
        name: 'Model performance metrics',
      },
      {
        uri: 'taxonomy:1f7346f8-2576-4fdd-b402-fc14acd4be15',
        name: 'Conversational AI',
      },
      {
        uri: 'taxonomy:cc3ac547-d51b-4d3e-80db-8c86910d1766',
        name: 'Rice framework',
      },
      {
        uri: 'taxonomy:4b0e9c36-43df-4a55-a103-590f44969783',
        name: 'Recommendation engine fluency',
      },
      {
        uri: 'taxonomy:cb5d3826-959b-4362-b823-5097b8477fcd',
        name: 'GenAI Strategy',
      },
      {
        uri: 'taxonomy:d2a8ff67-b649-4f3c-a39d-daff01daf41b',
        name: 'Product roadmaps',
      },
    ],
    schools: [
      {
        uri: 'taxonomy:b8b37a22-80bb-45fe-8c41-7d7179cc306d',
        name: 'artificial intelligence',
      },
      {
        uri: 'taxonomy:0dba323e-c4c6-4d09-bf98-365cf420a83a',
        name: 'product management',
      },
    ],
    title: 'AI Product Manager',
    semanticType: 'Degree',
    duration: '4 weeks',
    rawDuration: 1065,
    rawDurationDisplay: '18 hours',
    summary:
      'This Nanodegree program equips you to manage AI products from concept to launch. Learn AI integration, design custom datasets, and develop strategies for Generative AI. You’ll create a PRD, build roadmaps, and explore LLMs in product strategies.\n',
  },
  {
    key: 'nd002',
    slug: 'data-analyst-nanodegree--nd002',
    hasStagingData: true,
    isFree: false,
    image: 'https://video.udacity-data.com/topher/2024/October/67098715_nd002/nd002.jpg',
    syllabus: {
      asset: {
        url: 'https://cdn.sanity.io/files/tlr8oxjg/production/661a2013432b2e8c5b65f369f823e86dd0db47f4.pdf',
      },
    },
    programDescriptionOverride: null,
    reviewSummary: {
      numberOfReviews: 1242,
      starsAverage: 4.8,
    },
    createdAt: '2021-09-17T15:04:03.325Z',
    difficultyLevel: 'Intermediate',
    teachesSkills: [],
    schools: [
      {
        uri: 'taxonomy:0797c703-1d76-487a-9219-b84cf74b66a5',
        name: 'data science',
      },
    ],
    title: 'Data Analyst',
    semanticType: 'Degree',
    duration: '2 months',
    rawDuration: 2605,
    rawDurationDisplay: '43 hours',
    summary:
      "Clean up messy data, uncover patterns and insights, and communicate your findings. You'll start with an introduction to data analysis tools, including Jupyter Notebook, NumPy, pandas, and Matplotlib. Using these tools, you will ask questions about data and answer them through data collection, exploration, wrangling, and visualization. This intermediate-level program includes real-world projects where you will choose your own datasets, research questions, and analysis approach. As you progress through the program, each course will repeat the data analysis process while introducing more advanced techniques, such as applying data imputation to fill in missing data and applying appropriate encodings when developing data visualizations.",
  },
  {
    key: 'nd189',
    slug: 'aws-machine-learning-engineer-nanodegree--nd189',
    hasStagingData: false,
    isFree: false,
    image: 'https://video.udacity-data.com/topher/2024/October/67098799_nd189/nd189.jpg',
    syllabus: {
      asset: {
        url: 'https://cdn.sanity.io/files/tlr8oxjg/production/3373b280a2a718b47073fab5682368b943dff1ca.pdf',
      },
    },
    programDescriptionOverride: null,
    reviewSummary: {
      numberOfReviews: 48,
      starsAverage: 4.6,
    },
    createdAt: '2021-09-27T23:04:03.358Z',
    difficultyLevel: 'Intermediate',
    teachesSkills: [],
    schools: [
      {
        uri: 'taxonomy:b8b37a22-80bb-45fe-8c41-7d7179cc306d',
        name: 'artificial intelligence',
      },
    ],
    title: 'AWS Machine Learning Engineer Nanodegree',
    semanticType: 'Degree',
    duration: '4 months',
    rawDuration: 5635,
    rawDurationDisplay: '94 hours',
    summary:
      'Refine your machine learning skills with this AWS Machine Learning Engineer Nanodegree. Learn to deploy models on SageMaker and design automated workflows with AWS Lambda and Step Functions.',
  },
  {
    key: 'nd027',
    slug: 'data-engineer-nanodegree--nd027',
    hasStagingData: true,
    isFree: false,
    image: 'https://video.udacity-data.com/topher/2024/October/67098746_nd027/nd027.jpg',
    syllabus: {
      asset: {
        url: 'https://cdn.sanity.io/files/tlr8oxjg/production/03c8ab94c8ee5380391a58b65f73ad55cec46f49.pdf',
      },
    },
    programDescriptionOverride: null,
    reviewSummary: {
      numberOfReviews: 1249,
      starsAverage: 4.6,
    },
    createdAt: '2021-10-06T19:25:07.203Z',
    difficultyLevel: 'Intermediate',
    teachesSkills: [],
    schools: [
      {
        uri: 'taxonomy:0797c703-1d76-487a-9219-b84cf74b66a5',
        name: 'data science',
      },
    ],
    title: 'Data Engineering with AWS',
    semanticType: 'Degree',
    duration: '2 months',
    rawDuration: 2395,
    rawDurationDisplay: '40 hours',
    summary:
      'Learn to design data models, build data warehouses and data lakes, automate data pipelines, and work with massive datasets.',
  },
  {
    key: 'nd213',
    slug: 'c-plus-plus-nanodegree--nd213',
    hasStagingData: true,
    isFree: false,
    image: 'https://video.udacity-data.com/topher/2024/October/6709879e_nd213/nd213.jpg',
    syllabus: {
      asset: {
        url: 'https://cdn.sanity.io/files/tlr8oxjg/production/f5a7764da9c8b5ac21fbb09ea5dff1940d49b711.pdf',
      },
    },
    programDescriptionOverride: null,
    reviewSummary: {
      numberOfReviews: 811,
      starsAverage: 4.6,
    },
    createdAt: '2021-10-06T21:11:32.926Z',
    difficultyLevel: 'Intermediate',
    teachesSkills: [],
    schools: [
      {
        uri: 'taxonomy:d5b00600-d85f-4c4a-a493-e7ed9374be89',
        name: 'programming and development',
      },
    ],
    title: 'C++ ',
    semanticType: 'Degree',
    duration: '3 months',
    rawDuration: 3723,
    rawDurationDisplay: '62 hours',
    summary:
      "Learn C++, a high-performance programming language used in the world's most exciting engineering jobs -- from self-driving cars and robotics to web browsers, media platforms, servers, and video games.",
  },
  {
    key: 'nd104',
    slug: 'programming-for-data-science-nanodegree--nd104',
    hasStagingData: true,
    isFree: false,
    image: 'https://video.udacity-data.com/topher/2024/October/6709878e_nd104/nd104.jpg',
    syllabus: {
      asset: {
        url: 'https://cdn.sanity.io/files/tlr8oxjg/production/e8ee3dc899bf9548704c9b909e1befbd6e93457d.pdf',
      },
    },
    programDescriptionOverride: null,
    reviewSummary: {
      numberOfReviews: 833,
      starsAverage: 4.8,
    },
    createdAt: '2021-10-04T18:22:56.252Z',
    difficultyLevel: 'Beginner',
    teachesSkills: [],
    schools: [
      {
        uri: 'taxonomy:b8b37a22-80bb-45fe-8c41-7d7179cc306d',
        name: 'artificial intelligence',
      },
      {
        uri: 'taxonomy:c7075247-28e1-4047-9a11-d86f2a3143d5',
        name: 'autonomous systems',
      },
      {
        uri: 'taxonomy:0797c703-1d76-487a-9219-b84cf74b66a5',
        name: 'data science',
      },
    ],
    title: 'Programming for Data Science with Python',
    semanticType: 'Degree',
    duration: '2 months',
    rawDuration: 3187,
    rawDurationDisplay: '53 hours',
    summary:
      'Learn programming skills needed to uncover patterns and insights in large data sets, running queries with relational databases and working with Unix shell and Git.',
  },
  {
    key: 'nd098',
    slug: 'business-analytics-nanodegree--nd098',
    hasStagingData: true,
    isFree: false,
    image:
      'https://video.udacity-data.com/topher/2025/July/688bc1c2_nd1-business-analytics-with-tableau-plp-1456-x-821/nd1-business-analytics-with-tableau-plp-1456-x-821.jpg',
    syllabus: null,
    programDescriptionOverride: null,
    reviewSummary: {
      numberOfReviews: 1247,
      starsAverage: 4.8,
    },
    createdAt: '2021-09-17T15:26:32.291Z',
    difficultyLevel: 'Beginner',
    teachesSkills: [],
    schools: [
      {
        uri: 'taxonomy:0797c703-1d76-487a-9219-b84cf74b66a5',
        name: 'data science',
      },
      {
        uri: 'taxonomy:0797c703-1d76-487a-9219-b84cf74b66a5',
        name: 'data science',
      },
      {
        uri: 'taxonomy:0797c703-1d76-487a-9219-b84cf74b66a5',
        name: 'data science',
      },
      {
        uri: 'taxonomy:63c3498c-9e8b-4d85-bcd4-2843d519ee04',
        name: 'business',
      },
      {
        uri: 'taxonomy:0797c703-1d76-487a-9219-b84cf74b66a5',
        name: 'data science',
      },
      {
        uri: 'taxonomy:0797c703-1d76-487a-9219-b84cf74b66a5',
        name: 'data science',
      },
      {
        uri: 'taxonomy:0797c703-1d76-487a-9219-b84cf74b66a5',
        name: 'data science',
      },
      {
        uri: 'taxonomy:0dba323e-c4c6-4d09-bf98-365cf420a83a',
        name: 'product management',
      },
    ],
    title: 'Business Analytics with Tableau',
    semanticType: 'Degree',
    duration: '2 months',
    rawDuration: 2396,
    rawDurationDisplay: '40 hours',
    summary:
      'Dive into business analytics with this Nanodegre. Master Excel, SQL, and Tableau to analyze data, create interactive dashboards, and deliver insights that drive informed, impactful business decisions.',
  },
  {
    key: 'nd018',
    slug: 'digital-marketing-nanodegree--nd018',
    hasStagingData: true,
    isFree: false,
    image: 'https://video.udacity-data.com/topher/2024/October/67098737_nd018/nd018.jpg',
    syllabus: null,
    programDescriptionOverride: null,
    reviewSummary: {
      numberOfReviews: 1019,
      starsAverage: 4.7,
    },
    createdAt: '2021-10-06T21:10:41.046Z',
    difficultyLevel: 'Beginner',
    teachesSkills: [],
    schools: [
      {
        uri: 'taxonomy:63c3498c-9e8b-4d85-bcd4-2843d519ee04',
        name: 'business',
      },
    ],
    title: 'Digital Marketing',
    semanticType: 'Degree',
    duration: '3 months',
    rawDuration: 4355,
    rawDurationDisplay: '73 hours',
    summary:
      'Build job-ready digital marketing skills by learning from industry experts. Run live campaigns, analyze results, and apply proven techniques to engage audiences and strengthen brand performance in this comprehensive Nanodegree.',
  },
  {
    key: 'nd101',
    slug: 'deep-learning-nanodegree--nd101',
    hasStagingData: true,
    isFree: false,
    image: 'https://video.udacity-data.com/topher/2024/October/67098786_nd101/nd101.jpg',
    syllabus: null,
    programDescriptionOverride: null,
    reviewSummary: {
      numberOfReviews: 968,
      starsAverage: 4.7,
    },
    createdAt: '2021-10-27T17:56:56.176Z',
    difficultyLevel: 'Intermediate',
    teachesSkills: [],
    schools: [
      {
        uri: 'taxonomy:b8b37a22-80bb-45fe-8c41-7d7179cc306d',
        name: 'artificial intelligence',
      },
    ],
    title: 'Deep Learning',
    semanticType: 'Degree',
    duration: '3 months',
    rawDuration: 3635,
    rawDurationDisplay: '61 hours',
    summary:
      'Build foundational skills in deep learning by designing and training neural networks to solve complex real-world problems. You’ll begin with the essentials of neural networks, advancing to specialized architectures like Convolutional and Recurrent Neural Networks, along with Generative Adversarial Networks. Through projects, create models for applications such as image classification, sentiment analysis, and face generation, gaining hands-on experience with PyTorch and advanced training techniques. Ideal for those aiming to harness the potential of deep learning, this experience prepares you to tackle AI challenges across various domains.',
  },
];

export const topAiSkillsCatalogItems: CatalogItem[] = [
  {
    key: 'nd608',
    slug: 'generative-ai--nd608',
    hasStagingData: false,
    isFree: false,
    image:
      'https://video.udacity-data.com/topher/2025/November/69178ba1_generative-ai-nd-mocha-1200x900/generative-ai-nd-mocha-1200x900.jpg',
    syllabus: {
      asset: {
        url: 'https://cdn.sanity.io/files/tlr8oxjg/production/b545cc3ab39710604fc3dd28d16ae10ce85b4535.pdf',
      },
    },
    programDescriptionOverride: null,
    reviewSummary: { numberOfReviews: 13, starsAverage: 4.8 },
    createdAt: '2023-09-11T19:40:36.398Z',
    difficultyLevel: 'Intermediate',
    teachesSkills: [],
    schools: [{ uri: 'taxonomy:b8b37a22-80bb-45fe-8c41-7d7179cc306d', name: 'artificial intelligence' }],
    title: 'Generative AI',
    semanticType: 'Degree',
    duration: '2 months',
    rawDuration: 2995,
    rawDurationDisplay: '50 hours',
    summary:
      "Embark on a transformative journey into Generative AI!  We'll start by diving into the essentials with an introductory course, progress to mastering text generation with Large Language Models, unravel the complexities of image creation in computer vision and cap it off by bringing AI to life in real-world applications. From foundational theories to building sophisticated chatbots and AI agents, this program will empower you with job-ready skills in the exciting field of Generative AI.",
  },
  {
    key: 'nd089',
    slug: 'ai-programming-python-nanodegree--nd089',
    hasStagingData: true,
    isFree: false,
    image: 'https://video.udacity-data.com/topher/2024/October/6709877c_nd089/nd089.jpg',
    syllabus: {
      asset: {
        url: 'https://cdn.sanity.io/files/tlr8oxjg/production/85a57092f82acfa28186b72fd7017ce61a9cb9f6.pdf',
      },
    },
    programDescriptionOverride: null,
    reviewSummary: { numberOfReviews: 624, starsAverage: 4.7 },
    createdAt: '2021-10-25T18:42:11.381Z',
    difficultyLevel: 'Beginner',
    teachesSkills: [],
    schools: [
      { uri: 'taxonomy:b8b37a22-80bb-45fe-8c41-7d7179cc306d', name: 'artificial intelligence' },
      { uri: 'taxonomy:c7075247-28e1-4047-9a11-d86f2a3143d5', name: 'autonomous systems' },
      { uri: 'taxonomy:d5b00600-d85f-4c4a-a493-e7ed9374be89', name: 'programming and development' },
      { uri: 'taxonomy:0797c703-1d76-487a-9219-b84cf74b66a5', name: 'data science' },
    ],
    title: 'AI Programming with Python',
    semanticType: 'Degree',
    duration: '3 months',
    rawDuration: 4362,
    rawDurationDisplay: '73 hours',
    summary:
      'Develop a strong foundation in Python programming for AI, utilizing tools like NumPy, pandas, and Matplotlib for data analysis and visualization. Learn how to use, build, and train machine learning models with popular Python libraries. Implement neural networks using PyTorch. Gain practical experience with deep learning frameworks by applying your skills through hands-on projects. Explore generative AI with Transformer neural networks, learn to build, train, and deploy them with PyTorch, and leverage pre-trained models for natural language processing tasks. Designed for individuals with basic programming experience, this program prepares you for advanced studies in AI and machine learning, equipping you with the skills to begin a career in AI programming.',
  },
  {
    key: 'nd027',
    slug: 'data-engineer-nanodegree--nd027',
    hasStagingData: true,
    isFree: false,
    image: 'https://video.udacity-data.com/topher/2024/October/67098746_nd027/nd027.jpg',
    syllabus: {
      asset: {
        url: 'https://cdn.sanity.io/files/tlr8oxjg/production/03c8ab94c8ee5380391a58b65f73ad55cec46f49.pdf',
      },
    },
    programDescriptionOverride: null,
    reviewSummary: { numberOfReviews: 1248, starsAverage: 4.6 },
    createdAt: '2021-10-06T19:25:07.203Z',
    difficultyLevel: 'Intermediate',
    teachesSkills: [],
    schools: [{ uri: 'taxonomy:0797c703-1d76-487a-9219-b84cf74b66a5', name: 'data science' }],
    title: 'Data Engineering with AWS',
    semanticType: 'Degree',
    duration: '2 months',
    rawDuration: 2395,
    rawDurationDisplay: '40 hours',
    summary:
      'Learn to design data models, build data warehouses and data lakes, automate data pipelines, and work with massive datasets.',
  },
  {
    key: 'nd881',
    slug: 'ai-trading-strategies--nd881',
    hasStagingData: false,
    isFree: false,
    image: 'https://video.udacity-data.com/topher/2024/October/671fea7e_ai_for_trading/ai_for_trading.jpeg',
    syllabus: null,
    programDescriptionOverride: null,
    reviewSummary: { numberOfReviews: 0, starsAverage: 0 },
    createdAt: '2024-10-02T16:07:16.058Z',
    difficultyLevel: 'Advanced',
    teachesSkills: [
      { uri: 'taxonomy:50ae698a-09d7-4c98-a101-d8d5ff6e0ef3', name: 'Automated plan optimization' },
      { uri: 'taxonomy:b77ad51a-4a20-47d5-b042-14137401b4b9', name: 'Backtesting' },
    ],
    schools: [{ uri: 'taxonomy:b8b37a22-80bb-45fe-8c41-7d7179cc306d', name: 'artificial intelligence' }],
    title: 'AI Trading Strategies',
    semanticType: 'Degree',
    duration: '4 months',
    rawDuration: 5755,
    rawDurationDisplay: '96 hours',
    summary:
      'The goal of the AI Trading Strategies Nanodegree program is to provide learners with the knowledge to build an AI based trading model. This includes ideation, preprocessing, model development, backtesting, and optimization. ',
  },
  {
    key: 'nd104',
    slug: 'programming-for-data-science-nanodegree--nd104',
    hasStagingData: true,
    isFree: false,
    image: 'https://video.udacity-data.com/topher/2024/October/6709878e_nd104/nd104.jpg',
    syllabus: {
      asset: {
        url: 'https://cdn.sanity.io/files/tlr8oxjg/production/e8ee3dc899bf9548704c9b909e1befbd6e93457d.pdf',
      },
    },
    programDescriptionOverride: null,
    reviewSummary: { numberOfReviews: 832, starsAverage: 4.8 },
    createdAt: '2021-10-04T18:22:56.252Z',
    difficultyLevel: 'Beginner',
    teachesSkills: [],
    schools: [
      { uri: 'taxonomy:b8b37a22-80bb-45fe-8c41-7d7179cc306d', name: 'artificial intelligence' },
      { uri: 'taxonomy:c7075247-28e1-4047-9a11-d86f2a3143d5', name: 'autonomous systems' },
      { uri: 'taxonomy:0797c703-1d76-487a-9219-b84cf74b66a5', name: 'data science' },
    ],
    title: 'Programming for Data Science with Python',
    semanticType: 'Degree',
    duration: '2 months',
    rawDuration: 3187,
    rawDurationDisplay: '53 hours',
    summary:
      'Learn programming skills needed to uncover patterns and insights in large data sets, running queries with relational databases and working with Unix shell and Git.',
  },
  {
    key: 'nd025',
    slug: 'data-scientist-nanodegree--nd025',
    hasStagingData: true,
    isFree: false,
    image:
      'https://video.udacity-data.com/topher/2024/December/6764ad84_data-scientist-nanodegree-refresh-plp/data-scientist-nanodegree-refresh-plp.jpeg',
    syllabus: null,
    programDescriptionOverride: null,
    reviewSummary: { numberOfReviews: 809, starsAverage: 4.8 },
    createdAt: '2021-06-21T14:53:06.633Z',
    difficultyLevel: 'Advanced',
    teachesSkills: [],
    schools: [{ uri: 'taxonomy:0797c703-1d76-487a-9219-b84cf74b66a5', name: 'data science' }],
    title: 'Data Scientist',
    semanticType: 'Degree',
    duration: '3 months',
    rawDuration: 3670,
    rawDurationDisplay: '61 hours',
    summary:
      'What if you could recommend the perfect movie, predict housing prices to guide smart investments, or anticipate healthcare outcomes like diabetes and breast cancer? These are just a few of the challenges Data Scientists tackle every day. Data science is the driving force behind solving complex problems across industries. It can help HR departments retain their employees, allow policymakers to predict economic outcomes, and even enable NASA scientists to monitor environmental changes. In this program, you’ll not only tackle these real-world applications but also gain the skills to envision new solutions yourself. You’ll build projects that directly mirror the work done by data scientists in the field, incorporating the latest AI tools in both your workflows and your deliverables.',
  },
  {
    key: 'nd002',
    slug: 'data-analyst-nanodegree--nd002',
    hasStagingData: true,
    isFree: false,
    image: 'https://video.udacity-data.com/topher/2024/October/67098715_nd002/nd002.jpg',
    syllabus: {
      asset: {
        url: 'https://cdn.sanity.io/files/tlr8oxjg/production/661a2013432b2e8c5b65f369f823e86dd0db47f4.pdf',
      },
    },
    programDescriptionOverride: null,
    reviewSummary: { numberOfReviews: 1233, starsAverage: 4.8 },
    createdAt: '2021-09-17T15:04:03.325Z',
    difficultyLevel: 'Intermediate',
    teachesSkills: [],
    schools: [{ uri: 'taxonomy:0797c703-1d76-487a-9219-b84cf74b66a5', name: 'data science' }],
    title: 'Data Analyst',
    semanticType: 'Degree',
    duration: '2 months',
    rawDuration: 2605,
    rawDurationDisplay: '43 hours',
    summary:
      "Clean up messy data, uncover patterns and insights, and communicate your findings. You'll start with an introduction to data analysis tools, including Jupyter Notebook, NumPy, pandas, and Matplotlib. Using these tools, you will ask questions about data and answer them through data collection, exploration, wrangling, and visualization. This intermediate-level program includes real-world projects where you will choose your own datasets, research questions, and analysis approach. As you progress through the program, each course will repeat the data analysis process while introducing more advanced techniques, such as applying data imputation to fill in missing data and applying appropriate encodings when developing data visualizations.",
  },
  {
    key: 'nd098',
    slug: 'business-analytics-nanodegree--nd098',
    hasStagingData: true,
    isFree: false,
    image: 'https://video.udacity-data.com/topher/2024/October/67098782_nd098/nd098.jpg',
    syllabus: {
      asset: {
        url: 'https://cdn.sanity.io/files/tlr8oxjg/production/5b94ab2de3ae0abed09e3487832a216203b65ded.pdf',
      },
    },
    programDescriptionOverride: null,
    reviewSummary: { numberOfReviews: 1245, starsAverage: 4.8 },
    createdAt: '2021-09-17T15:26:32.291Z',
    difficultyLevel: 'Beginner',
    teachesSkills: [],
    schools: [
      { uri: 'taxonomy:0797c703-1d76-487a-9219-b84cf74b66a5', name: 'data science' },
      { uri: 'taxonomy:0dba323e-c4c6-4d09-bf98-365cf420a83a', name: 'product management' },
      { uri: 'taxonomy:63c3498c-9e8b-4d85-bcd4-2843d519ee04', name: 'business' },
    ],
    title: 'Business Analytics',
    semanticType: 'Degree',
    duration: '3 months',
    rawDuration: 4112,
    rawDurationDisplay: '69 hours',
    summary:
      'Master essential data analysis skills to drive informed business decisions across industries. This program covers data fundamentals, teaching you to collect, analyze, and visualize data using Excel, SQL, and Tableau. Learn to work with spreadsheets, perform statistical analysis, create financial models, and build interactive dashboards. Apply your skills to real-world projects, such as analyzing NYSE S&P financial data and optimizing business practices using a digital music store database. Gain proficiency in data-driven decision-making, financial forecasting, and creating impactful visualizations. This program is designed for aspiring business analysts and professionals seeking to enhance their data analysis and interpretation capabilities in a business context.',
  },
  {
    key: 'nd101',
    slug: 'deep-learning-nanodegree--nd101',
    hasStagingData: true,
    isFree: false,
    image: 'https://video.udacity-data.com/topher/2024/October/67098786_nd101/nd101.jpg',
    syllabus: null,
    programDescriptionOverride: null,
    reviewSummary: { numberOfReviews: 966, starsAverage: 4.7 },
    createdAt: '2021-10-27T17:56:56.176Z',
    difficultyLevel: 'Intermediate',
    teachesSkills: [],
    schools: [{ uri: 'taxonomy:b8b37a22-80bb-45fe-8c41-7d7179cc306d', name: 'artificial intelligence' }],
    title: 'Deep Learning',
    semanticType: 'Degree',
    duration: '3 months',
    rawDuration: 3635,
    rawDurationDisplay: '61 hours',
    summary:
      'Build foundational skills in deep learning by designing and training neural networks to solve complex real-world problems. You’ll begin with the essentials of neural networks, advancing to specialized architectures like Convolutional and Recurrent Neural Networks, along with Generative Adversarial Networks. Through projects, create models for applications such as image classification, sentiment analysis, and face generation, gaining hands-on experience with PyTorch and advanced training techniques. Ideal for those aiming to harness the potential of deep learning, this experience prepares you to tackle AI challenges across various domains.',
  },
  {
    key: 'nd893',
    slug: 'deep-reinforcement-learning-nanodegree--nd893',
    hasStagingData: true,
    isFree: false,
    image: 'https://video.udacity-data.com/topher/2024/October/670987cf_nd893/nd893.jpg',
    syllabus: {
      asset: {
        url: 'https://cdn.sanity.io/files/tlr8oxjg/production/6f578beef2a3bbd821964564fa85511af8319858.pdf',
      },
    },
    programDescriptionOverride: null,
    reviewSummary: { numberOfReviews: 356, starsAverage: 4.6 },
    createdAt: '2021-10-25T18:48:39.643Z',
    difficultyLevel: 'Advanced',
    teachesSkills: [],
    schools: [{ uri: 'taxonomy:b8b37a22-80bb-45fe-8c41-7d7179cc306d', name: 'artificial intelligence' }],
    title: 'Deep Reinforcement Learning',
    semanticType: 'Degree',
    duration: '4 months',
    rawDuration: 5000,
    rawDurationDisplay: '83 hours',
    summary:
      'Develop advanced AI solutions with applications ranging from robotics to financial trading. To gain a foundation in AI techniques, you will implement classical solution methods, define Markov decision processes, policies, and value functions, and derive Bellman equations. Then, you will learn dynamic programming, Monte Carlo methods, temporal-difference methods, and deep reinforcement learning (deep RL) and apply these techniques to solve real-world problems. You will train agents to navigate virtual worlds, generate optimal financial trading strategies, and apply RL to multiple interacting agents.',
  },
  {
    key: 'nd00333',
    slug: 'machine-learning-engineer-for-microsoft-azure-nanodegree--nd00333',
    hasStagingData: true,
    isFree: false,
    image: 'https://video.udacity-data.com/topher/2024/October/67098728_nd00333/nd00333.jpg',
    syllabus: {
      asset: {
        url: 'https://cdn.sanity.io/files/tlr8oxjg/production/a9f67135dd0a2400b3b97c4ba3aa0cdb210c0726.pdf',
      },
    },
    programDescriptionOverride: null,
    reviewSummary: { numberOfReviews: 83, starsAverage: 4.1 },
    createdAt: '2021-09-22T15:26:33.590Z',
    difficultyLevel: 'Intermediate',
    teachesSkills: [],
    schools: [{ uri: 'taxonomy:b8b37a22-80bb-45fe-8c41-7d7179cc306d', name: 'artificial intelligence' }],
    title: 'Machine Learning Engineer with Microsoft Azure',
    semanticType: 'Degree',
    duration: '2 months',
    rawDuration: 2385,
    rawDurationDisplay: '40 hours',
    summary:
      'Learn Azure ML Operations and the skills utilized by Azure Machine Learning Engineers. Gain a working knowledge of workspaces, datastores, key components of a machine learning pipeline, and how to deploy models and consume endpoints. Demonstrate knowledge learned through the building, deployment, and analysis of two customized models in a capstone project. \n',
  },
  {
    key: 'nd891',
    slug: 'computer-vision-nanodegree--nd891',
    hasStagingData: true,
    isFree: false,
    image: 'https://video.udacity-data.com/topher/2024/October/670987c9_nd891/nd891.jpg',
    syllabus: {
      asset: {
        url: 'https://cdn.sanity.io/files/tlr8oxjg/production/706588d34cb6cef65a8d377f8949752a49cc711b.pdf',
      },
    },
    programDescriptionOverride: null,
    reviewSummary: { numberOfReviews: 477, starsAverage: 4.7 },
    createdAt: '2021-12-16T16:52:36.568Z',
    difficultyLevel: 'Advanced',
    teachesSkills: [],
    schools: [{ uri: 'taxonomy:b8b37a22-80bb-45fe-8c41-7d7179cc306d', name: 'artificial intelligence' }],
    title: 'Computer Vision',
    semanticType: 'Degree',
    duration: '2 months',
    rawDuration: 2235,
    rawDurationDisplay: '37 hours',
    summary:
      'Master the computer vision skills behind advances in robotics and automation. Write programs to analyze images, implement feature extraction, and recognize objects using deep learning models.',
  },
  {
    key: 'nd0821',
    slug: 'machine-learning-dev-ops-engineer-nanodegree--nd0821',
    hasStagingData: false,
    isFree: false,
    image: 'https://video.udacity-data.com/topher/2024/October/67098774_nd0821/nd0821.jpg',
    syllabus: {
      asset: {
        url: 'https://cdn.sanity.io/files/tlr8oxjg/production/24147169701feae3817ab007a5b9c335ec655a29.pdf',
      },
    },
    programDescriptionOverride: null,
    reviewSummary: { numberOfReviews: 101, starsAverage: 4.6 },
    createdAt: '2021-06-25T20:05:44.237Z',
    difficultyLevel: 'Advanced',
    teachesSkills: [],
    schools: [{ uri: 'taxonomy:b8b37a22-80bb-45fe-8c41-7d7179cc306d', name: 'artificial intelligence' }],
    title: 'Machine Learning DevOps Engineer',
    semanticType: 'Degree',
    duration: '3 months',
    rawDuration: 3805,
    rawDurationDisplay: '63 hours',
    summary:
      'Automate and streamline the deployment of machine learning models, combining software engineering principles with machine learning workflows. This program covers key skills like writing production-ready code, creating reproducible workflows, and building automated deployment pipelines. Through real-world projects, you’ll develop scalable pipelines, version control for data and models, monitor model performance, and implement CI/CD processes to ensure resilient, maintainable systems. Ideal for data scientists aiming to operationalize their models, these skills empower you to build effective, long-term solutions tailored for industry demands.',
  },
  {
    key: 'nd898',
    slug: 'ai-artificial-intelligence-nanodegree--nd898',
    hasStagingData: true,
    isFree: false,
    image: 'https://video.udacity-data.com/topher/2024/October/670987d2_nd898/nd898.jpg',
    syllabus: null,
    programDescriptionOverride: null,
    reviewSummary: { numberOfReviews: 186, starsAverage: 4.5 },
    createdAt: '2021-10-25T18:55:53.608Z',
    difficultyLevel: 'Advanced',
    teachesSkills: [],
    schools: [{ uri: 'taxonomy:b8b37a22-80bb-45fe-8c41-7d7179cc306d', name: 'artificial intelligence' }],
    title: 'Artificial Intelligence',
    semanticType: 'Degree',
    duration: '2 months',
    rawDuration: 2410,
    rawDurationDisplay: '40 hours',
    summary:
      'Master the foundations of artificial intelligence by exploring essential AI techniques, including search algorithms, symbolic logic, and planning systems. This program guides you through building intelligent agents that can strategize, optimize, and make decisions independently. Engage in hands-on projects where you’ll construct algorithms for problem-solving and automated planning used in robotics and complex logistical systems. You’ll learn to design AI solutions using proven methods, from iterative optimization techniques to advanced search methods, preparing you to solve real-world challenges.',
  },
  {
    key: 'nd038',
    slug: 'data-architect-nanodegree--nd038',
    hasStagingData: true,
    isFree: false,
    image: 'https://video.udacity-data.com/topher/2024/October/6709875a_nd038/nd038.jpg',
    syllabus: {
      asset: {
        url: 'https://cdn.sanity.io/files/tlr8oxjg/production/ec30e17792cde03437d27ec98e9d28e21f69e6bc.pdf',
      },
    },
    programDescriptionOverride: null,
    reviewSummary: { numberOfReviews: 91, starsAverage: 4.5 },
    createdAt: '2021-10-06T21:06:00.814Z',
    difficultyLevel: 'Advanced',
    teachesSkills: [],
    schools: [{ uri: 'taxonomy:0797c703-1d76-487a-9219-b84cf74b66a5', name: 'data science' }],
    title: 'Data Architect',
    semanticType: 'Degree',
    duration: '3 months',
    rawDuration: 4360,
    rawDurationDisplay: '73 hours',
    summary:
      "Gain the expertise to structure, manage, and safeguard enterprise-level data systems with this program. You'll learn advanced skills in database design, data modeling, and cloud integration, equipping you to make data-driven decisions and architect resilient systems for modern businesses. With a focus on high-demand skills, this program also covers essential topics in data security and governance, ensuring you're prepared to build scalable, efficient, and secure data infrastructures tailored to organizational needs.",
  },
  {
    key: 'nd054',
    slug: 'ai-for-business-leaders--nd054',
    hasStagingData: true,
    isFree: false,
    image: 'https://video.udacity-data.com/topher/2024/October/67098763_nd054/nd054.jpg',
    syllabus: {
      asset: {
        url: 'https://cdn.sanity.io/files/tlr8oxjg/production/8344ad615584097ded93e2fad938cf3c829ba862.pdf',
      },
    },
    programDescriptionOverride: null,
    reviewSummary: { numberOfReviews: 90, starsAverage: 4.5 },
    createdAt: '2021-10-27T18:09:55.518Z',
    difficultyLevel: 'Beginner',
    teachesSkills: [],
    schools: [
      { uri: 'taxonomy:1ab68afb-1a62-434e-bffd-7d0f18975299', name: 'executive leadership' },
      { uri: 'taxonomy:b8b37a22-80bb-45fe-8c41-7d7179cc306d', name: 'artificial intelligence' },
    ],
    title: 'AI For Business Leaders',
    semanticType: 'Degree',
    duration: '1 month',
    rawDuration: 1650,
    rawDurationDisplay: '28 hours',
    summary:
      'Formulate and evaluate proposals grounded in first principles when assessing opportunities to embed machine learning and artificial intelligence into a corporate strategy. ',
  },
  {
    key: 'nd229',
    slug: 'intro-to-machine-learning-nanodegree--nd229',
    hasStagingData: true,
    isFree: false,
    image: 'https://video.udacity-data.com/topher/2024/October/670987a4_nd229/nd229.jpg',
    syllabus: {
      asset: {
        url: 'https://cdn.sanity.io/files/tlr8oxjg/production/42b2ac54fc91625dc0f4836303f7133961d07c60.pdf',
      },
    },
    programDescriptionOverride: null,
    reviewSummary: { numberOfReviews: 248, starsAverage: 4.7 },
    createdAt: '2021-10-04T18:24:23.783Z',
    difficultyLevel: 'Intermediate',
    teachesSkills: [],
    schools: [{ uri: 'taxonomy:b8b37a22-80bb-45fe-8c41-7d7179cc306d', name: 'artificial intelligence' }],
    title: 'Introduction to Machine Learning with Pytorch',
    semanticType: 'Degree',
    duration: '2 months',
    rawDuration: 2956,
    rawDurationDisplay: '49 hours',
    summary:
      "Build powerful machine learning models to make predictions and uncover hidden patterns. Start with foundational supervised learning algorithms, including linear regression, decision trees, naive Bayes, support vector machines (SVMs), and perceptrons, then evaluate your model performance with a variety of evaluation metrics. Then, you'll advance from perceptrons to deep neural networks in order to perform supervised learning on complex data sources such as images. Finally, you'll dive into unsupervised learning methods, including clustering and dimensionality reduction for customer segmentation. For each technique, you'll start by learning the underlying math, then implement real-world models with Python libraries, including PyTorch and scikit-learn.",
  },
  {
    key: 'cd0024',
    slug: 'introduction-to-python--cd0024',
    hasStagingData: false,
    isFree: false,
    image: 'https://video.udacity-data.com/topher/2024/October/67098186_cd0024/cd0024.jpg',
    syllabus: {
      asset: {
        url: 'https://cdn.sanity.io/files/tlr8oxjg/production/8da1e4e17fcd7d1fe5000285fca00930aa758d82.pdf',
      },
    },
    programDescriptionOverride: null,
    reviewSummary: { numberOfReviews: 0, starsAverage: 0 },
    createdAt: '2021-08-12T18:06:39.512Z',
    difficultyLevel: 'Beginner',
    teachesSkills: [
      { uri: 'taxonomy:be7c9123-6544-42c5-b178-eca36ccf86c1', name: 'User input handling' },
      { uri: 'taxonomy:7f2a8e2e-942d-4a5a-991e-19b15a2d0d8a', name: 'NumPy' },
      { uri: 'taxonomy:2ff31eb8-bfeb-43e0-b65e-a9582f66636e', name: 'Python function definition' },
      { uri: 'taxonomy:5c6a7ee4-e996-47af-b033-1a9cbbd660e8', name: 'Python syntax' },
      { uri: 'taxonomy:7c709830-ff4b-4f36-a8cb-6223513f2ad0', name: 'List comprehension' },
      { uri: 'taxonomy:ec18340d-0ef5-4f68-a787-07952d16860e', name: 'Python methods' },
      { uri: 'taxonomy:d9230e27-1b3f-40a4-992b-41c7228ec680', name: 'Built-in Python functions' },
      { uri: 'taxonomy:313f9e63-6025-4128-95a1-5d746d866346', name: 'Variable scope' },
      { uri: 'taxonomy:fe93853f-6656-45b8-9d7f-20f201cafbfa', name: 'Pandas' },
      { uri: 'taxonomy:3b68ebfb-70e8-4c4d-8b41-d585282ad43e', name: 'Python ides' },
      { uri: 'taxonomy:93ac5928-e522-4d53-a980-c935d801b471', name: 'Anaconda' },
      { uri: 'taxonomy:4ab88158-053b-458a-8171-3be4abf05a21', name: 'Docstrings' },
      { uri: 'taxonomy:687078a6-4624-4781-9ae4-dfe7908aaf98', name: 'Python data structures' },
      { uri: 'taxonomy:203a2fef-1ca9-42f1-b1ea-2f1174c00a8b', name: 'Python operators' },
      { uri: 'taxonomy:9291ecc0-3db1-4076-9872-4530c61fdb6d', name: 'Control flow' },
      { uri: 'taxonomy:6b9e8c28-64fd-4579-8bc5-ab2f70d4fe50', name: 'Python best practices' },
      { uri: 'taxonomy:36be3ca9-ac99-459e-b4b1-6b70ed3691a5', name: 'Python exception handling' },
      { uri: 'taxonomy:8acf3128-f447-4dfe-8e23-88cafe71f60f', name: 'Python scripting' },
      { uri: 'taxonomy:8e7fadbe-bb62-45fc-acfc-33f6f120aa98', name: 'Iterators' },
      { uri: 'taxonomy:8fe5053d-f6ab-4990-8e13-0050af2742b6', name: 'Python data types' },
      { uri: 'taxonomy:eedca040-2366-42f5-8eaf-93ad5658f662', name: 'Python package management' },
    ],
    schools: [{ uri: 'taxonomy:0797c703-1d76-487a-9219-b84cf74b66a5', name: 'data science' }],
    title: 'Introduction to Python ',
    semanticType: 'Part',
    duration: '4 weeks',
    rawDuration: 1210,
    rawDurationDisplay: '20 hours',
    summary:
      'Learn Python programming fundamentals such as data types and structures, variables, loops, and functions.',
  },
];

export const in30DaysCatalogItems: CatalogItem[] = [
  {
    key: 'cd0024',
    slug: 'introduction-to-python--cd0024',
    hasStagingData: false,
    isFree: false,
    image: 'https://video.udacity-data.com/topher/2024/October/67098186_cd0024/cd0024.jpg',
    syllabus: {
      asset: {
        url: 'https://cdn.sanity.io/files/tlr8oxjg/production/8da1e4e17fcd7d1fe5000285fca00930aa758d82.pdf',
      },
    },
    programDescriptionOverride: null,
    reviewSummary: { numberOfReviews: 0, starsAverage: 0 },
    createdAt: '2021-08-12T18:06:39.512Z',
    difficultyLevel: 'Beginner',
    teachesSkills: [
      { uri: 'taxonomy:be7c9123-6544-42c5-b178-eca36ccf86c1', name: 'User input handling' },
      { uri: 'taxonomy:7f2a8e2e-942d-4a5a-991e-19b15a2d0d8a', name: 'NumPy' },
      { uri: 'taxonomy:2ff31eb8-bfeb-43e0-b65e-a9582f66636e', name: 'Python function definition' },
      { uri: 'taxonomy:5c6a7ee4-e996-47af-b033-1a9cbbd660e8', name: 'Python syntax' },
      { uri: 'taxonomy:7c709830-ff4b-4f36-a8cb-6223513f2ad0', name: 'List comprehension' },
      { uri: 'taxonomy:ec18340d-0ef5-4f68-a787-07952d16860e', name: 'Python methods' },
      { uri: 'taxonomy:d9230e27-1b3f-40a4-992b-41c7228ec680', name: 'Built-in Python functions' },
      { uri: 'taxonomy:313f9e63-6025-4128-95a1-5d746d866346', name: 'Variable scope' },
      { uri: 'taxonomy:fe93853f-6656-45b8-9d7f-20f201cafbfa', name: 'Pandas' },
      { uri: 'taxonomy:3b68ebfb-70e8-4c4d-8b41-d585282ad43e', name: 'Python ides' },
      { uri: 'taxonomy:93ac5928-e522-4d53-a980-c935d801b471', name: 'Anaconda' },
      { uri: 'taxonomy:4ab88158-053b-458a-8171-3be4abf05a21', name: 'Docstrings' },
      { uri: 'taxonomy:687078a6-4624-4781-9ae4-dfe7908aaf98', name: 'Python data structures' },
      { uri: 'taxonomy:203a2fef-1ca9-42f1-b1ea-2f1174c00a8b', name: 'Python operators' },
      { uri: 'taxonomy:9291ecc0-3db1-4076-9872-4530c61fdb6d', name: 'Control flow' },
      { uri: 'taxonomy:6b9e8c28-64fd-4579-8bc5-ab2f70d4fe50', name: 'Python best practices' },
      { uri: 'taxonomy:36be3ca9-ac99-459e-b4b1-6b70ed3691a5', name: 'Python exception handling' },
      { uri: 'taxonomy:8acf3128-f447-4dfe-8e23-88cafe71f60f', name: 'Python scripting' },
      { uri: 'taxonomy:8e7fadbe-bb62-45fc-acfc-33f6f120aa98', name: 'Iterators' },
      { uri: 'taxonomy:8fe5053d-f6ab-4990-8e13-0050af2742b6', name: 'Python data types' },
      { uri: 'taxonomy:eedca040-2366-42f5-8eaf-93ad5658f662', name: 'Python package management' },
    ],
    schools: [{ uri: 'taxonomy:0797c703-1d76-487a-9219-b84cf74b66a5', name: 'data science' }],
    title: 'Introduction to Python ',
    semanticType: 'Part',
    duration: '4 weeks',
    rawDuration: 1210,
    rawDurationDisplay: '20 hours',
    summary:
      'Learn Python programming fundamentals such as data types and structures, variables, loops, and functions.',
  },
  {
    key: 'cd13230',
    slug: 'generative-AI-for-business-leaders--cd13230',
    hasStagingData: false,
    isFree: false,
    image: 'https://video.udacity-data.com/topher/2024/October/670985e8_cd13230/cd13230.jpg',
    syllabus: null,
    programDescriptionOverride: null,
    reviewSummary: { numberOfReviews: 0, starsAverage: 0 },
    createdAt: '2023-08-21T19:52:08.449Z',
    difficultyLevel: 'Intermediate',
    teachesSkills: [
      { uri: 'taxonomy:cb5d3826-959b-4362-b823-5097b8477fcd', name: 'GenAI Strategy' },
      { uri: 'taxonomy:3ad3115d-d485-4476-b588-ec662094208b', name: 'Generative AI Fluency' },
      { uri: 'taxonomy:4eb5ffeb-bc00-4524-b37d-5d8e9820dc13', name: 'GenAI Models' },
      { uri: 'taxonomy:77203da3-1fc0-42fa-8ead-730099bc94a1', name: 'Machine learning system architectures' },
      { uri: 'taxonomy:d2a8ff67-b649-4f3c-a39d-daff01daf41b', name: 'Product roadmaps' },
      { uri: 'taxonomy:4fe5fbfa-b6e5-4601-9e04-633cf1ea3fe3', name: 'AI business context' },
      { uri: 'taxonomy:7d001a7a-e39e-4878-bd5a-722918af2d1c', name: 'Building AI Teams' },
      { uri: 'taxonomy:bd4a8a0d-0481-400d-96ad-c03545344b64', name: 'GenAI Use Cases' },
      { uri: 'taxonomy:affa4f03-8600-4f39-85d1-2c9731e6b2b4', name: 'Model performance metrics' },
      { uri: 'taxonomy:25b0069f-948d-4d34-b824-f184b09abfea', name: 'Product management basics' },
    ],
    schools: [
      { uri: 'taxonomy:b8b37a22-80bb-45fe-8c41-7d7179cc306d', name: 'artificial intelligence' },
      { uri: 'taxonomy:1ab68afb-1a62-434e-bffd-7d0f18975299', name: 'executive leadership' },
    ],
    title: 'Generative AI for Business Leaders',
    semanticType: 'Part',
    duration: '3 weeks',
    rawDuration: 835,
    rawDurationDisplay: '14 hours',
    summary:
      'Equip yourself to lead in the age of AI by understanding how to strategically implement generative AI within your business. This program provides practical insights into AI capabilities, limitations, and ethical considerations, helping you identify impactful use cases and make informed decisions about AI adoption. Learn to leverage AI tools to drive innovation, enhance customer experiences, and optimize operations while fostering a responsible AI approach that aligns with organizational goals and values.',
  },
  {
    key: 'cd13318',
    slug: 'large-language-models-and-text-generation--cd13318',
    hasStagingData: false,
    isFree: false,
    image: 'https://video.udacity-data.com/topher/2024/October/67098600_cd13318/cd13318.jpg',
    syllabus: null,
    programDescriptionOverride: null,
    reviewSummary: { numberOfReviews: 0, starsAverage: 0 },
    createdAt: '2023-09-12T03:32:48.632Z',
    difficultyLevel: 'Intermediate',
    teachesSkills: [
      { uri: 'taxonomy:389b2380-b011-4b37-80ae-b47897c1ee00', name: 'Data scraping' },
      { uri: 'taxonomy:2df23c86-f1d3-484b-8a81-9dc0ccdc49ba', name: 'Word embeddings' },
      { uri: 'taxonomy:d2f74e13-f7f5-469c-9961-a1d64c83dae1', name: 'Data quality assessment' },
      { uri: 'taxonomy:d73b10d9-f971-4e93-8e56-c21186ff38e2', name: 'Beautifulsoup' },
      { uri: 'taxonomy:ebf6457f-eca7-41bc-a1ed-bafecf3d4172', name: 'Text generation' },
      { uri: 'taxonomy:32ab011e-4042-4bdc-9987-47ae04194294', name: 'Attention mechanisms' },
      { uri: 'taxonomy:f9b16601-2200-4f29-9c4a-e286cbd31960', name: 'Recurrent neural networks' },
      { uri: 'taxonomy:3dd1c342-4d1c-44ed-872c-09c505f5efcc', name: 'API requests' },
      { uri: 'taxonomy:2e997b8c-24d2-4ef3-ae32-9dcdfd5ea766', name: 'Cosine' },
      { uri: 'taxonomy:d1963c75-4674-4d31-8e1f-b7de465d4348', name: 'Tokenization' },
      { uri: 'taxonomy:1dcdcab3-b1af-473f-a5cd-883cca2a760b', name: 'PyTorch' },
      { uri: 'taxonomy:fe93853f-6656-45b8-9d7f-20f201cafbfa', name: 'Pandas' },
      { uri: 'taxonomy:01d8bddd-e76a-44b4-94b3-50bc7df373b4', name: 'Prompt Engineering' },
      { uri: 'taxonomy:73869043-af4b-441d-9562-178e716bd58c', name: 'Transformer neural networks' },
      { uri: 'taxonomy:580d491c-0976-4678-b23a-27da8516748d', name: 'Retrieval-Augmented Generation' },
      { uri: 'taxonomy:2fbf8df3-0dbb-4ad9-9ad0-ce9f832674c1', name: 'OpenAI API' },
      { uri: 'taxonomy:cb7b078b-e795-407c-8263-3775c1e35072', name: 'Bert' },
      { uri: 'taxonomy:a8d436f4-75b1-4dc9-8286-d141cd001ef8', name: 'Natural language processing' },
      { uri: 'taxonomy:9987cca4-48a2-416e-8c72-4c5a992ef174', name: 'Data cleaning' },
      { uri: 'taxonomy:567f4a1c-f285-4900-9528-ab00700de9c1', name: 'Large Language Models' },
      { uri: 'taxonomy:280c8c6c-1bb7-4adb-a034-971cb16f46dc', name: 'Selenium' },
      { uri: 'taxonomy:0cbdde39-edf9-46f6-8980-a419b9bd9891', name: 'GPT' },
      { uri: 'taxonomy:207e3904-e269-4312-a5c3-c8ad294c4e74', name: 'NLP transformers' },
      { uri: 'taxonomy:660c129d-43fb-467e-85a1-f6082c013ad3', name: 'Search implementation in Python' },
      { uri: 'taxonomy:bfff2fd7-0ebd-4c8c-b1cc-cb136eae2818', name: 'Together AI API' },
    ],
    schools: [{ uri: 'taxonomy:b8b37a22-80bb-45fe-8c41-7d7179cc306d', name: 'artificial intelligence' }],
    title: 'Large Language Models (LLMs) & Text Generation',
    semanticType: 'Part',
    duration: '2 weeks',
    rawDuration: 690,
    rawDurationDisplay: '12 hours',
    summary:
      "Dive deeper into how computers understand and create language, and learn how to build a custom chatbot using unsupervised machine learning, prompt engineering, and retrieval augmented generation. We'll start with a high-level overview of the types of LLMs, the differences between them, and how best to account for their strengths and weaknesses. Then we'll get into the internal details, including natural language processing (NLP) techniques like tokenization, as well as modern transformer architectures and attention mechanisms. Finally, we'll build a practical LLM application that combines an LLM with a custom dataset.",
  },
  {
    key: 'cd13678',
    slug: 'intro-to-rust--cd13678',
    hasStagingData: false,
    isFree: false,
    image: 'https://video.udacity-data.com/topher/2024/October/6717d1b9_rust-plp-with-logo/rust-plp-with-logo.jpg',
    syllabus: null,
    programDescriptionOverride: null,
    reviewSummary: { numberOfReviews: 0, starsAverage: 0 },
    createdAt: '2024-04-26T14:50:44.180Z',
    difficultyLevel: 'Advanced',
    teachesSkills: [
      { uri: 'taxonomy:6201fed5-7fe5-4bdf-a654-d9c4c2417a3b', name: 'Rust Advanced Types' },
      { uri: 'taxonomy:c600780f-2916-48dc-bfaa-a7ff22ac758e', name: 'Control Flow in Rust' },
      { uri: 'taxonomy:23eef872-aa90-4dc0-bf8b-0ee3ee7d075e', name: 'Rust' },
      { uri: 'taxonomy:2f3f69a4-a0b9-416f-9987-a3d08abbbda6', name: 'Traits and Generics in Rust' },
      { uri: 'taxonomy:d8888030-ff96-4e84-95be-f5d75421195f', name: 'Concurrency in Rust' },
      { uri: 'taxonomy:b3311a4a-0abc-4843-b14c-951f7ce48e1e', name: 'Rust Macros' },
      { uri: 'taxonomy:91c140bb-ede4-4d33-a5c1-2a9bb11e69e5', name: 'Rust Data Types' },
      { uri: 'taxonomy:531a2723-dfeb-4138-a3d1-4135c3da7a5e', name: 'Rust Basics' },
      { uri: 'taxonomy:3dd79c56-12de-4987-878f-82ffade67226', name: 'Concurrent computing' },
      { uri: 'taxonomy:4c2a2285-b159-4bb8-a93f-91c04a38d12c', name: 'Rust FFI' },
      { uri: 'taxonomy:64da4eb4-5ccc-4928-8c89-1a983383ed8f', name: 'Rust Cargo and Crates' },
      { uri: 'taxonomy:655241d3-0a2b-4e38-acba-47bc7da6d498', name: 'Rust Functions and Modules' },
      { uri: 'taxonomy:aae0e470-f183-46e6-8043-4d378adef0f4', name: 'Ownership and Borrowing in Rust' },
      { uri: 'taxonomy:bcce0c02-1084-431d-b26f-c8af739414b7', name: 'Testing in Rust' },
    ],
    schools: [
      { uri: 'taxonomy:d5b00600-d85f-4c4a-a493-e7ed9374be89', name: 'programming and development' },
      { uri: 'taxonomy:c7075247-28e1-4047-9a11-d86f2a3143d5', name: 'autonomous systems' },
      { uri: 'taxonomy:b4a305f0-00bb-4c2c-bcfd-e875edcdcd61', name: 'cybersecurity' },
    ],
    title: 'Introduction to Rust',
    semanticType: 'Part',
    duration: '2 weeks',
    rawDuration: 450,
    rawDurationDisplay: '8 hours',
    summary:
      "In this course, you'll learn Rust from the ground up, equipping you with the skills to build efficient and scalable Rust applications.",
  },
  {
    key: 'cd13224',
    slug: 'generative-ai-fluency--cd13224',
    hasStagingData: false,
    isFree: false,
    image: 'https://video.udacity-data.com/topher/2024/October/670985e2_cd13224/cd13224.jpg',
    syllabus: null,
    programDescriptionOverride: null,
    reviewSummary: { numberOfReviews: 0, starsAverage: 0 },
    createdAt: '2023-08-16T00:37:56.412Z',
    difficultyLevel: 'Fluency',
    teachesSkills: [{ uri: 'taxonomy:3ad3115d-d485-4476-b588-ec662094208b', name: 'Generative AI Fluency' }],
    schools: [{ uri: 'taxonomy:b8b37a22-80bb-45fe-8c41-7d7179cc306d', name: 'artificial intelligence' }],
    title: 'Generative AI Fluency',
    semanticType: 'Part',
    duration: '1 week',
    rawDuration: 415,
    rawDurationDisplay: '7 hours',
    summary:
      'This course provides a comprehensive high-level overview of Generative AI, beginning with foundational concepts and terminology and then delving into specific applications such as Large Language Models (LLMs) for text generation and diffusion-based models image creation. Key lessons include an in-depth look at LLMs, AI image generation methods, and hands-on experience with tools like DALL-E and Midjourney. The course concludes by addressing practical aspects of deploying Generative AI in production environments, focusing on data collection, prompt execution, maintenance, and orchestration strategies.',
  },
  {
    key: 'cd2019',
    slug: 'discovering-ai-ml--cd2019',
    hasStagingData: false,
    isFree: false,
    image: 'https://video.udacity-data.com/topher/2024/October/6709868a_cd2019/cd2019.jpg',
    syllabus: null,
    programDescriptionOverride: null,
    reviewSummary: { numberOfReviews: 0, starsAverage: 0 },
    createdAt: '2022-01-16T00:50:36.296Z',
    difficultyLevel: 'Discovery',
    teachesSkills: [
      { uri: 'taxonomy:46f32e2e-f5f4-4219-9455-4e1a77cb4df0', name: 'Artificial Intelligence Awareness' },
    ],
    schools: [{ uri: 'taxonomy:b8b37a22-80bb-45fe-8c41-7d7179cc306d', name: 'artificial intelligence' }],
    title: 'Discovering Artificial Intelligence and Machine Learning',
    semanticType: 'Part',
    duration: '1 hour',
    rawDuration: 60,
    rawDurationDisplay: '1 hour',
    summary:
      'Discover Artificial Intelligence and Machine Learning, learn about how they work, and find out how they are used to solve problems in new ways that were never possible in the past.',
  },
  {
    key: 'cd0021',
    slug: 'introduction-to-sql--cd0021',
    hasStagingData: false,
    isFree: false,
    image: 'https://video.udacity-data.com/topher/2024/October/67098185_cd0021/cd0021.jpg',
    syllabus: {
      asset: {
        url: 'https://cdn.sanity.io/files/tlr8oxjg/production/95b2f14c6ce4f2d108d46767c02ba34d96f9f572.pdf',
      },
    },
    programDescriptionOverride: null,
    reviewSummary: { numberOfReviews: 0, starsAverage: 0 },
    createdAt: '2021-08-12T22:56:27.067Z',
    difficultyLevel: 'Beginner',
    teachesSkills: [
      { uri: 'taxonomy:9987cca4-48a2-416e-8c72-4c5a992ef174', name: 'Data cleaning' },
      { uri: 'taxonomy:9eb25966-eeb0-4a5d-9bd4-a5a8514d97fa', name: 'SQL queries' },
      { uri: 'taxonomy:0ee41af0-d99d-46db-8224-68aa550c1bcc', name: 'SQL window functions' },
      { uri: 'taxonomy:a8d16198-df8e-4bb2-ae63-a76186c06c40', name: 'SQL joins' },
      { uri: 'taxonomy:ec897090-f727-438a-b85d-08cb5d096312', name: 'SQL subqueries' },
      { uri: 'taxonomy:bd97042c-8b4d-4819-a3a4-28979e621908', name: 'SQL aggregations' },
      { uri: 'taxonomy:e63da129-7393-4a11-a16c-6d0e9f0c71c4', name: 'SQL query performance tuning' },
    ],
    schools: [{ uri: 'taxonomy:d5b00600-d85f-4c4a-a493-e7ed9374be89', name: 'programming and development' }],
    title: 'Introduction to SQL',
    semanticType: 'Part',
    duration: '4 weeks',
    rawDuration: 1110,
    rawDurationDisplay: '19 hours',
    summary:
      'SQL is one of the most versatile tools available for extracting insights from stored data.\nLearn how to execute core SQL commands to define, select, manipulate, control access, aggregate, and join data and data tables. Understand when and how to use subqueries, several window functions, and partitions to complete complex tasks. Clean data, optimize SQL queries and write select advanced JOINs to enhance analysis performance, explain which cases you would want to use particular SQL commands, and apply the results from queries to address business problems. \n',
  },
  {
    key: 'cd13054',
    slug: 'how-to-use-chatgpt--cd13054',
    hasStagingData: false,
    isFree: false,
    image: 'https://video.udacity-data.com/topher/2024/October/670985bf_cd13054/cd13054.jpg',
    syllabus: null,
    programDescriptionOverride: null,
    reviewSummary: { numberOfReviews: 0, starsAverage: 0 },
    createdAt: '2023-06-29T20:54:10.854Z',
    difficultyLevel: 'Fluency',
    teachesSkills: [{ uri: 'taxonomy:a2fb17d7-13c9-4141-9ef5-6c0100a3df89', name: 'ChatGPT Fluency' }],
    schools: [{ uri: 'taxonomy:b8b37a22-80bb-45fe-8c41-7d7179cc306d', name: 'artificial intelligence' }],
    title: 'How to Use ChatGPT',
    semanticType: 'Part',
    duration: '3 hours',
    rawDuration: 160,
    rawDurationDisplay: '3 hours',
    summary:
      "Harness the impressive capabilities of OpenAI's popular large language model (LLM). This course explains the technology behind how ChatGPT works while teaching how to write strategic prompts that yield high-quality outputs.",
  },
  {
    key: 'cd13232',
    slug: 'generative-AI-with-AWS--cd13232',
    hasStagingData: false,
    isFree: false,
    image: 'https://video.udacity-data.com/topher/2024/October/670985eb_cd13232/cd13232.jpg',
    syllabus: null,
    programDescriptionOverride: null,
    reviewSummary: { numberOfReviews: 0, starsAverage: 0 },
    createdAt: '2023-08-21T20:56:12.378Z',
    difficultyLevel: 'Beginner',
    teachesSkills: [
      { uri: 'taxonomy:93a493d2-1499-4f23-9bb0-4ce1f8d1a947', name: 'Basic supervised machine learning' },
      { uri: 'taxonomy:01d8bddd-e76a-44b4-94b3-50bc7df373b4', name: 'Prompt Engineering' },
      { uri: 'taxonomy:3ad3115d-d485-4476-b588-ec662094208b', name: 'Generative AI Fluency' },
      { uri: 'taxonomy:3a5361e5-405d-48eb-a76b-1222ce4b1501', name: 'Convolutional neural networks' },
      { uri: 'taxonomy:6ffb1cd1-0e31-4d73-ae1b-5adbc7b3cd49', name: 'Amazon sagemaker' },
      { uri: 'taxonomy:3a5361e5-405d-48eb-a76b-1222ce4b1501', name: 'Convolutional neural networks' },
    ],
    schools: [{ uri: 'taxonomy:b8b37a22-80bb-45fe-8c41-7d7179cc306d', name: 'artificial intelligence' }],
    title: 'Introducing Generative AI with AWS',
    semanticType: 'Part',
    duration: '2 weeks',
    rawDuration: 690,
    rawDurationDisplay: '12 hours',
    summary:
      "Master the fundamentals of generative AI and develop a deep understanding of its historical context and real-world applications. Explore AI and machine learning foundations using AWS tools, large language models (LLMs) with transformer-based architectures, and the societal impacts of generative AI to understand AI's evolution and ethical deployment. Engage in exercises on AI history, machine learning approaches, prompt engineering, and responsible AI use to apply your knowledge in practical scenarios. Develop skills in distinguishing AI from ML, exploring LLMs, and emphasizing ethical AI deployment, enabling you to apply these concepts in real-world applications. Designed for learners with basic Python knowledge, this program empowers you to advance your understanding of generative AI.",
  },
  {
    key: 'cd11970',
    slug: 'golang--cd11970',
    hasStagingData: false,
    isFree: false,
    image: 'https://video.udacity-data.com/topher/2024/October/670981b2_cd11970/cd11970.jpg',
    syllabus: {
      asset: {
        url: 'https://cdn.sanity.io/files/tlr8oxjg/production/d732620255c007b4f9d412b9708b9e92c6107d83.pdf',
      },
    },
    programDescriptionOverride: null,
    reviewSummary: { numberOfReviews: 1, starsAverage: 4 },
    createdAt: '2022-04-27T22:38:28.879Z',
    difficultyLevel: 'Intermediate',
    teachesSkills: [
      { uri: 'taxonomy:857036fc-1a39-4f29-bcc3-c2374ca33dac', name: 'Go Range' },
      { uri: 'taxonomy:8ae6b4de-65ad-482b-aa09-c98b134fc2cf', name: 'Goroutines' },
      { uri: 'taxonomy:0e0aa327-0c87-4511-b49d-1449bd563ce7', name: 'Go Slices' },
      { uri: 'taxonomy:d4b42c47-edb9-45b7-b2ae-f815a328f365', name: 'Go Arrays' },
      { uri: 'taxonomy:9b7a9850-0874-4979-a836-8541aaf4fc63', name: 'Go Conditionals' },
      { uri: 'taxonomy:6e5e1dd3-76e1-44c2-8bce-e16317cb2df2', name: 'Go Maps' },
      { uri: 'taxonomy:124306bb-96fc-4904-9709-e815e2b6b7bf', name: 'Go Structs' },
      { uri: 'taxonomy:e475efb0-db37-40a2-bffb-bb1ee57fb29f', name: 'Go Variables' },
      { uri: 'taxonomy:8ebdd390-3bbd-4dd5-903d-f1cf2513a2cf', name: 'Go Loops' },
      { uri: 'taxonomy:baf54c68-f119-47c0-8888-6fdebae09129', name: 'Go Interfaces' },
      { uri: 'taxonomy:5b6cdf0e-1531-4825-932b-7a8591546ad7', name: 'Go Functions' },
    ],
    schools: [{ uri: 'taxonomy:d5b00600-d85f-4c4a-a493-e7ed9374be89', name: 'programming and development' }],
    title: 'Go Language (Golang)',
    semanticType: 'Part',
    duration: '2 weeks',
    rawDuration: 720,
    rawDurationDisplay: '12 hours',
    summary:
      'Students will learn the fundamentals skills, including variables, loops, data structures, functions, interfaces, structs, and maps.  Then students will use those skills to test and build an actual web server.',
  },
  {
    key: 'cd13409',
    slug: 'c-programming--cd13409',
    hasStagingData: false,
    isFree: false,
    image:
      'https://video.udacity-data.com/topher/2025/January/679293ef_c-programming-plp-1456-x-817/c-programming-plp-1456-x-817.jpg',
    syllabus: null,
    programDescriptionOverride: null,
    reviewSummary: { numberOfReviews: 0, starsAverage: 0 },
    createdAt: '2023-10-19T15:06:39.831Z',
    difficultyLevel: 'Beginner',
    teachesSkills: [
      { uri: 'taxonomy:76a4cb63-6747-4a2c-a131-7bc24efd9229', name: 'C Arrays' },
      { uri: 'taxonomy:2c7dd33c-4034-4906-979f-7c1e375d494a', name: 'File I/O in C' },
      { uri: 'taxonomy:2a70376a-d7c5-4c29-9a72-1b6a31443fdf', name: 'C Syntax' },
      { uri: 'taxonomy:0510df04-41cd-4b61-9bb1-44d3d49246b1', name: 'Control Flow in C' },
      { uri: 'taxonomy:723e398b-2f60-40b5-80ac-f8b64954d10d', name: 'Exception Handling in C' },
      { uri: 'taxonomy:5f11f6bb-b453-4f5e-a39b-e0714b4f4f84', name: 'C Functions' },
      { uri: 'taxonomy:c0b73ae8-ee5d-4f3a-af9a-1cb16add0a05', name: 'Memory Management in C' },
      { uri: 'taxonomy:79e949b8-29dc-4fa7-88bd-8098ee60758e', name: 'C Dynamic Memory Allocation' },
      { uri: 'taxonomy:bf8fa96a-4dd1-4b43-9082-02cf7c8eaa16', name: 'C Data Types' },
      { uri: 'taxonomy:de922c3e-1bec-471b-8806-2d10ddc7f3c0', name: 'C Pointers' },
      { uri: 'taxonomy:9994c81d-40bf-4846-b631-b0b6a2381365', name: 'Basic C' },
    ],
    schools: [{ uri: 'taxonomy:c7075247-28e1-4047-9a11-d86f2a3143d5', name: 'autonomous systems' }],
    title: 'C Programming',
    semanticType: 'Part',
    duration: '2 weeks',
    rawDuration: 480,
    rawDurationDisplay: '8 hours',
    summary:
      "In this course, you'll gain a solid foundation in C programming by understanding how to work with data types, operators, and control structures to build logical workflows. You'll learn to create reusable code using functions, effectively manage data with arrays and pointers, and handle more complex data structures with structs and unions. Through hands-on exercises, you'll master memory management, debugging techniques, and error handling, culminating in a practical project where you'll develop a file compression tool yourself.",
  },
  {
    key: 'cd12792',
    slug: 'build-a-custom-chatbot-with-openAI-api--cd12792',
    hasStagingData: false,
    isFree: false,
    image: 'https://video.udacity-data.com/topher/2024/October/67098594_cd12792/cd12792.jpg',
    syllabus: null,
    programDescriptionOverride: null,
    reviewSummary: { numberOfReviews: 0, starsAverage: 0 },
    createdAt: '2023-02-28T19:49:32.401Z',
    difficultyLevel: 'Intermediate',
    teachesSkills: [
      { uri: 'taxonomy:2df23c86-f1d3-484b-8a81-9dc0ccdc49ba', name: 'Word embeddings' },
      { uri: 'taxonomy:ebf6457f-eca7-41bc-a1ed-bafecf3d4172', name: 'Text generation' },
      { uri: 'taxonomy:1f7346f8-2576-4fdd-b402-fc14acd4be15', name: 'Conversational AI' },
      { uri: 'taxonomy:01d8bddd-e76a-44b4-94b3-50bc7df373b4', name: 'Prompt Engineering' },
      { uri: 'taxonomy:d1963c75-4674-4d31-8e1f-b7de465d4348', name: 'Tokenization' },
      { uri: 'taxonomy:2fbf8df3-0dbb-4ad9-9ad0-ce9f832674c1', name: 'OpenAI API' },
    ],
    schools: [{ uri: 'taxonomy:b8b37a22-80bb-45fe-8c41-7d7179cc306d', name: 'artificial intelligence' }],
    title: 'Building a Custom OpenAI Chatbot',
    semanticType: 'Part',
    duration: '1 week',
    rawDuration: 350,
    rawDurationDisplay: '6 hours',
    summary:
      "In this course, we will create a custom Q&A bot powered by OpenAI! Along the way, you'll learn how OpenAI works and how to leverage its powerful language processing capabilities to build a functional Q&A bot that can provide insightful answers to your questions and impress your friends with its knowledge.\n\nWe'll start by creating an unsupervised machine-learning workflow to match the user's question to the relevant context in our dataset. We'll use that workflow to send a custom prompt that includes this context to an OpenAI text completion model. The output will be a custom response that is better aligned with our user's need for accurate data about recent events.",
  },
  {
    key: 'cd13764',
    slug: 'ai-agents-with-langchain-and-langgraph--cd13764',
    hasStagingData: false,
    isFree: false,
    image:
      'https://video.udacity-data.com/topher/2025/March/67dcb5cc_ai-agents-with-langchain-and-langgraph-plp-1456-x-823/ai-agents-with-langchain-and-langgraph-plp-1456-x-823.jpg',
    syllabus: null,
    programDescriptionOverride: null,
    reviewSummary: { numberOfReviews: 0, starsAverage: 0 },
    createdAt: '2024-06-04T15:14:14.373Z',
    difficultyLevel: 'Intermediate',
    teachesSkills: [
      { uri: 'taxonomy:165bed4e-920d-47e1-847a-f6f269a009b9', name: 'LangChain' },
      { uri: 'taxonomy:34f45587-61aa-4e79-991e-2e153137522a', name: 'LangGraph' },
      { uri: 'taxonomy:b21d0457-0a64-4b95-9683-a3f703fac781', name: 'AI agents' },
      { uri: 'taxonomy:580d491c-0976-4678-b23a-27da8516748d', name: 'Retrieval-Augmented Generation' },
    ],
    schools: [{ uri: 'taxonomy:b8b37a22-80bb-45fe-8c41-7d7179cc306d', name: 'artificial intelligence' }],
    title: 'AI Agents with LangChain and LangGraph',
    semanticType: 'Part',
    duration: '3 weeks',
    rawDuration: 780,
    rawDurationDisplay: '13 hours',
    summary:
      'This course explores the use of LangChain and LangGraph for building advanced AI agent systems. It introduces learners to graph theory, state machines, and agentic systems, enabling them to build flexible AI-driven solutions for tasks such as knowledge retrieval using cyclical workflows.',
  },
  {
    key: 'cd13926',
    slug: 'building-generative-ai-applications-with-amazon-bedrock--cd13926',
    hasStagingData: false,
    isFree: false,
    image:
      'https://video.udacity-data.com/topher/2024/December/67631ee8_building-genai-applications-with-amazon-bedrock-and-python-plp/building-genai-applications-with-amazon-bedrock-and-python-plp.jpeg',
    syllabus: null,
    programDescriptionOverride: null,
    reviewSummary: { numberOfReviews: 0, starsAverage: 0 },
    createdAt: '2024-08-02T03:01:44.483Z',
    difficultyLevel: 'Beginner',
    teachesSkills: [
      { uri: 'taxonomy:567f4a1c-f285-4900-9528-ab00700de9c1', name: 'Large Language Models' },
      { uri: 'taxonomy:4eb5ffeb-bc00-4524-b37d-5d8e9820dc13', name: 'GenAI Models' },
      { uri: 'taxonomy:dc2f1a74-a96f-4477-8621-98807f5d9728', name: 'Amazon Web Services' },
      { uri: 'taxonomy:580d491c-0976-4678-b23a-27da8516748d', name: 'Retrieval-Augmented Generation' },
    ],
    schools: [{ uri: 'taxonomy:b8b37a22-80bb-45fe-8c41-7d7179cc306d', name: 'artificial intelligence' }],
    title: 'Building Generative AI Applications with Amazon Bedrock',
    semanticType: 'Part',
    duration: '2 weeks',
    rawDuration: 660,
    rawDurationDisplay: '11 hours',
    summary:
      "Build cutting-edge generative AI applications with Amazon Bedrock and Python. Learn to integrate models in applications using BOTO3 and APIs, leverage AWS services such as S3 and Amazon Aurora, and create end-to-end AI solutions. Through practical exercises and a real-world project, you'll gain expertise in Retrieval-Augmented Generation (RAG), embeddings, and secure AI pipelines. ",
  },
  {
    key: 'cd13908',
    slug: 'building-generative-ai-applications-for-data-insights-on-azure--cd13908',
    hasStagingData: false,
    isFree: false,
    image:
      'https://video.udacity-data.com/topher/2024/November/6732705a_building-generative-ai-applications-for-data-insights-on-azure-course/building-generative-ai-applications-for-data-insights-on-azure-course.jpeg',
    syllabus: null,
    programDescriptionOverride: null,
    reviewSummary: { numberOfReviews: 0, starsAverage: 0 },
    createdAt: '2024-07-23T14:27:15.257Z',
    difficultyLevel: 'Beginner',
    teachesSkills: [
      { uri: 'taxonomy:5f0c8ee6-c50d-4363-91e6-2d2ee5a7ac96', name: 'Azure AI Services' },
      { uri: 'taxonomy:580d491c-0976-4678-b23a-27da8516748d', name: 'Retrieval-Augmented Generation' },
    ],
    schools: [
      { uri: 'taxonomy:b8b37a22-80bb-45fe-8c41-7d7179cc306d', name: 'artificial intelligence' },
      { uri: 'taxonomy:37efa4cd-9fb8-48ed-a3be-4fe488e3704f', name: 'cloud computing' },
    ],
    title: 'Building Generative AI Applications for Data Insights on Azure',
    semanticType: 'Part',
    duration: '2 weeks',
    rawDuration: 480,
    rawDurationDisplay: '8 hours',
    summary:
      "You'll learn Azure OpenAI services, focusing on building applications that extract valuable insights from data using generative AI models. You'll set up and configure Azure AI tools, apply prompt engineering techniques, and integrate external data sources with retrieval-augmented generation (RAG) solutions. You'll gain practical experience in building AI-driven applications for data analysis.",
  },
  {
    key: 'cd13303',
    slug: 'generative-ai-fundamentals--cd13303',
    hasStagingData: false,
    isFree: false,
    image: 'https://video.udacity-data.com/topher/2024/October/670985fa_cd13303/cd13303.jpg',
    syllabus: null,
    programDescriptionOverride: null,
    reviewSummary: { numberOfReviews: 0, starsAverage: 0 },
    createdAt: '2023-09-07T22:54:27.368Z',
    difficultyLevel: 'Intermediate',
    teachesSkills: [
      { uri: 'taxonomy:7fa5d6de-0f16-4989-a2c0-136dd7e6ca72', name: 'Ethical AI' },
      { uri: 'taxonomy:68caf9aa-a950-4161-a6b5-9a6275c915dc', name: 'Foundation Models' },
      { uri: 'taxonomy:1dcdcab3-b1af-473f-a5cd-883cca2a760b', name: 'PyTorch' },
      { uri: 'taxonomy:f4834521-b707-466a-b837-a2c04ac0018c', name: 'Deep learning' },
      { uri: 'taxonomy:01d8bddd-e76a-44b4-94b3-50bc7df373b4', name: 'Prompt Engineering' },
      { uri: 'taxonomy:8dcca542-3cd8-420c-a507-f82127d8b604', name: 'Parameter-Efficient Fine-Tuning' },
      { uri: 'taxonomy:ded2e394-fe53-45ca-943a-78c15a171610', name: 'Hugging Face' },
      { uri: 'taxonomy:b0302509-7bc0-4b51-b47a-fbd3bc3a320f', name: 'Training neural networks' },
      { uri: 'taxonomy:922f23a5-23fe-4cb4-951f-26bc83155c1f', name: 'Transfer learning' },
      { uri: 'taxonomy:4f65fca2-6442-4c7d-b039-a5c2beecc1c9', name: 'Image classification' },
      { uri: 'taxonomy:3ad3115d-d485-4476-b588-ec662094208b', name: 'Generative AI Fluency' },
    ],
    schools: [{ uri: 'taxonomy:b8b37a22-80bb-45fe-8c41-7d7179cc306d', name: 'artificial intelligence' }],
    title: 'Generative AI Fundamentals',
    semanticType: 'Part',
    duration: '3 weeks',
    rawDuration: 810,
    rawDurationDisplay: '14 hours',
    summary:
      'Dive into generative AI with this course, which explores its fundamental principles and relationship to prior artificial intelligence innovations. We will walk through popular generative models and how they work, how deep learning models are developed using tools like PyTorch and Hugging Face, and finally, how to customize pre-trained open-source models for a specific use case. In the project, you will apply a cutting-edge technique called parameter-efficient fine-tuning (PEFT), which allows for the adaptation of massive foundation models with minimal usage of computational resources.',
  },
];
